import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

document.addEventListener('DOMContentLoaded', () => {
})

// window.addEventListener('resize', () => {
// })